import { useTranslation } from "react-i18next";
import { fetchBilling, updateBilling } from "../api";
import { BillingForm } from "./BillingForm";

/**
 * Settings → Billing (TW-3527) — club self-service editing of the club's invoicing identity
 * (company name, tax number/CIF, billing address) plus the accounting email invoices are sent to.
 * Mounted only for club users holding `billing.manage` (see SettingsPage). The legal-identity fields
 * are versioned server-side, so a future invoice can reference the exact details it was billed under.
 */
export function BillingSection() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="set-section-head" style={{ marginBottom: 18 }}>
        <h2>{t("settings.billing.heading")}</h2>
        <div className="sub">{t("settings.billing.sub")}</div>
      </div>
      <BillingForm load={fetchBilling} save={updateBilling} />
    </div>
  );
}
